import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedAdminRoute = ({ children }) => {
  const adminAuth = localStorage.getItem('adminAuth');
  
  if (!adminAuth) {
    return <Navigate to="/admin-login" replace />;
  }

  try {
    const auth = JSON.parse(adminAuth);
    if (!auth.isAuthenticated) {
      return <Navigate to="/admin-login" replace />;
    }
  } catch (err) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
